import { render, staticRenderFns } from "./pandect.vue?vue&type=template&id=3955a79c&scoped=true&"
import script from "./pandect.vue?vue&type=script&lang=js&"
export * from "./pandect.vue?vue&type=script&lang=js&"
import style0 from "./pandect.vue?vue&type=style&index=0&id=3955a79c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3955a79c",
  null
  
)

export default component.exports